interface LogoutConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export function LogoutConfirmModal({ isOpen, onClose, onConfirm }: LogoutConfirmModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl p-6 mx-4 max-w-sm w-full">
        <h3 className="text-[18px] font-semibold text-[#222222] text-center mb-4">
          로그아웃 하시겠습니까?
        </h3>
        <p className="text-[14px] text-[#666666] text-center mb-6">
          로그아웃 후에도 저장된 주소는 유지됩니다.
        </p>
        <div className="flex gap-3">
          <button
            onClick={onClose}
            className="flex-1 py-3 border border-[#DEDEDE] rounded-lg text-[16px] font-medium text-[#222222] hover:bg-gray-50 transition-colors"
          >
            취소
          </button>
          <button
            onClick={onConfirm}
            className="flex-1 py-3 bg-[#86DB89] rounded-lg text-[16px] font-medium text-white hover:opacity-90 transition-opacity"
          >
            로그아웃
          </button>
        </div>
      </div>
    </div>
  );
}